import { Search } from 'js-search'
import AdminContext from 'lib/context/AdminContext'
import AuthContext from 'lib/context/AuthContext'
import { events, track } from 'lib/util/analytics'
import createDebug from 'lib/util/createDebug'
import { PATHS, QUERY_KEYS, QUERY_VALUES } from 'lib/util/routing'
import { useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import useSearchQuery from './useSearchQuery'

const debug = createDebug('useSearchResults')

const sectionKeyByPathname = {
  [PATHS.webinars]: 'recordedWebinars',
  [PATHS.upcoming]: 'upcomingWebinars',
  [PATHS.videos]: 'videos'
}

export default function useSearchResults(searchIndex: Search) {
  const [results, setResults] = useState(null)
  const search = useSearchQuery()
  const location = useLocation()
  const { showAdminControls } = useContext(AdminContext)
  const { getAccessToken } = useContext(AuthContext)

  useEffect(() => {
    if (searchIndex) {
      if (search) {
        debug(`Setting results for [${search}]`)
        setResults(searchIndex.search(search))
      } else {
        debug('Clearing results')
        setResults(null)
      }
    }
  }, [search, searchIndex])

  useEffect(() => {
    if (search && search.length > 3 && results) {
      track(
        events.search,
        {
          searchTerm: search,
          section: sectionKeyByPathname[location.pathname],
          category: new URLSearchParams(location.search).get(QUERY_KEYS.category) || QUERY_VALUES.rise,
          hasResults: !!results.length,
          resultCount: results.length
        },
        getAccessToken,
        showAdminControls
      )
    }
    // ignore `search` to avoid double counting
  }, [results])

  return results
}
